var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skin-green",attrs:{"id":"main-wrapper"}},[_c('bo-header'),_c('bo-sidebar'),_c('router-view'),_c('bo-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }